import { EXTERNAL_LINKS } from 'src/const/links';

export function getAlvineLessonDetailUrl(lessonId?: number | null): string {
  if (!lessonId) {
    return EXTERNAL_LINKS.app.base;
  }

  const url = new URL('/index.php', EXTERNAL_LINKS.app.base);
  url.searchParams.set('sxx_page', 'smedex.de.themenbereiche.lektionsuebersicht.lektion_details');
  url.searchParams.set('sxx_call[a7816795ba][leid]', lessonId.toString());

  return url.toString();
}

export function getAlvineTasksOverviewUrl(): string {
  const url = new URL('/index.php', EXTERNAL_LINKS.app.base);
  url.searchParams.set(
    'sxx_page',
    'smedex.de.intern.mysmedex.administration.meine_aufgaben.pflicht_uebersicht'
  );
  url.searchParams.set('sxx_call[73619566dc][filter]', '1');
  url.searchParams.set('sxx_call[e4a7085d41][id]', 'e4a7085d41_25');

  return url.toString();
}
